// import React, { useState } from "react";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import "./testimonial.css";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import person1 from "../../../assets/person8.jpg";
// import person2 from "../../../assets/person2.jpeg";
// import person3 from "../../../assets/person3.jpeg";
// import person4 from "../../../assets/person4.jpeg";
// import person5 from "../../../assets/person5.jpeg";
// import { FaQuoteLeft } from "react-icons/fa";
// import Stars from "./Stars";
// import UseMediaQuery from "../UseMediaQuery";

// const Testimonial = () => {
//   const [isFirstSlide, setIsFirstSlide] = useState(true);
//   const [isLastSlide, setIsLastSlide] = useState(false);
//   const isMobile = UseMediaQuery("(max-width:486px)");

//   const data = [
//     {
//       img: person1,
//       title: "Maheshwari",
//       description: "SLV Trading Corporation, Begur",
//       description2:
//         "Delivered top-quality materials on time for our residential building project.",
//     },
//     {
//       img: person4,
//       title: "Ramesh Gowda",
//       description: "Sri Lakshmi Enterprises, Whitefield",
//       description2:
//         "Professional service and reliable concrete supply for commercial construction work.",
//     },
//     {
//       img: person2,
//       title: "Anitha ",
//       description: "Om Sai Constructions, KR Puram",
//       description2:
//         "Helped us design and construct our new office with excellent precision and work.",
//     },
//     {
//       img: person3,
//       title: "Manjunath Reddy",
//       description: "BuildTech Solutions, Marathahalli",
//       description2:
//         "Efficient team that delivered civil works with great attention to detail and construction.",
//     },
//     {
//       img: person5,
//       title: "Ramalinga",
//       description: "Modern Interiors, Yeshwanthapura",
//       description2:
//         "Transformed our interior spaces beautifully with creative design and finish.",
//     },
//   ];

//   const NextArrow = ({ onClick }) => (
//     <div
//       className={`testArrow testNext ${isLastSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowForward />
//     </div>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <div
//       className={`testArrow testPrev ${isFirstSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowBack />
//     </div>
//   );

//   const settings = {
//     infinite: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,

//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 486,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === data.length - 3);
//     },
//   };
//   const settings2 = {
//     infinite: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,

//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 486,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === data.length - 1);
//     },
//   };

//   return (
//     <div className="container mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-2 mt-sm-2 mt-2 mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3 mb-sm-2 mb-2">
//       <div className="row">
//         <div className="col-12 my-xl-4 my-lg-3  my-2">
//           <h3 className="abtMetsryh1 ">
//             What our <span className="banHeading">clients</span> say.
//           </h3>
//         </div>

//         {isMobile ? (
//           <Slider {...settings2} className="testimonial-slider">
//             {data?.map((item, i) => {
//               const { img, description, description2, title } = item;
//               return (
//                 <div key={i} className="p-3">
//                   {" "}
//                   {/* gap added here */}
//                   <div className="card testCardBg rounded-4 d-flex gap-3 shadow-sm">
//                     <div className="row g-0">
//                       <div className="testHeight">
//                         <FaQuoteLeft className="quotes mt-xl-5 mt-lg-5 my-3 mx-3 mb-3" />
//                         <h3 className="testih1 mb-3 p-3">{description2}</h3>
//                       </div>
//                       <div className="hrBorder "></div>
//                       <div className="col-3 d-flex justify-content-center align-items-center">
//                         <img
//                           src={img}
//                           className="img-fluid testImg"
//                           alt={title}
//                         />
//                       </div>
//                       <div className="col-9">
//                         <div className=" my-xl-4 my-lg-4 my-md-3 my-2">
//                           <h5 className="card-title testTitle">{title}</h5>
//                           <Stars stars={5} />
//                           <p className="card-text testText mt-2">
//                             {description}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </Slider>
//         ) : (
//           <Slider {...settings} className="testimonial-slider">
//             {data?.map((item, i) => {
//               const { img, description, description2, title } = item;
//               return (
//                 <div key={i} className="p-3">
//                   {" "}
//                   {/* gap added here */}
//                   <div className="card testCardBg rounded-4 d-flex gap-3 shadow-sm">
//                     <div className="row g-0">
//                       <div className="testHeight">
//                         <FaQuoteLeft className="quotes mt-xl-5 mt-lg-5 my-3 mx-3 mb-3" />
//                         <h3 className="testih1 mb-3 p-3">{description2}</h3>
//                       </div>
//                       <div className="hrBorder "></div>
//                       <div className="col-3 d-flex justify-content-center align-items-center">
//                         <img
//                           src={img}
//                           className="img-fluid testImg"
//                           alt={title}
//                         />
//                       </div>
//                       <div className="col-9">
//                         <div className=" my-xl-4 my-lg-4 my-md-3 my-2">
//                           <h5 className="card-title testTitle">{title}</h5>
//                           <Stars stars={5} />
//                           <p className="card-text testText mt-2">
//                             {description}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </Slider>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Testimonial;

// Imp don't delete

// import React, { useState } from "react";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import "./testimonial.css";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { FaPlay } from "react-icons/fa";
// import Modal from "react-bootstrap/Modal";
// import person1 from "../../../assets/person8.jpg";
// import person2 from "../../../assets/person2.jpeg";
// import person3 from "../../../assets/person3.jpeg";
// import person4 from "../../../assets/person4.jpeg";
// import person5 from "../../../assets/person5.jpeg";
// import { FaQuoteLeft } from "react-icons/fa";
// import Stars from "./Stars";
// import UseMediaQuery from "../UseMediaQuery";

// const Testimonial = () => {
//   const [isFirstSlide, setIsFirstSlide] = useState(true);
//   const [isLastSlide, setIsLastSlide] = useState(false);
//   const isMobile = UseMediaQuery("(max-width:486px)");
//   const [show, setShow] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const handleClose = () => setShow(false);
//   const handleShow = (index) => {
//     setActiveIndex(index); // set clicked video index
//     setShow(true);
//   };

//   const data = [
//     {
//       img: person1,
//       title: "Maheshwari",
//       description: "SLV Trading Corporation",
//       description2:
//         "Delivered top-quality materials on time for our residential building project.",
//       city: "Begur",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
//     },
//     {
//       img: person4,
//       title: "Ramesh Gowda",
//       description: "Sri Lakshmi Enterprises",
//       description2:
//         "Professional service and reliable concrete supply for commercial construction work.",
//       city: "Whitefield",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
//     },
//     {
//       img: person2,
//       title: "Anitha",
//       description: "Om Sai Constructions",
//       description2:
//         "Helped us design and construct our new office with excellent precision and work.",
//       city: "KR Puram",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
//     },
//     {
//       img: person3,
//       title: "Manjunath Reddy",
//       description: "BuildTech Solutions",
//       description2:
//         "Efficient team that delivered civil works with great attention to detail and construction.",
//       city: "Marathahalli",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
//     },
//     {
//       img: person5,
//       title: "Ramalinga",
//       description: "Modern Interiors",
//       description2:
//         "Transformed our interior spaces beautifully with creative design and finish.",
//       city: "Yeshwanthapura",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
//     },
//   ];

//   const NextArrow = ({ onClick }) => (
//     <div
//       className={`testArrow testNext ${isLastSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowForward />
//     </div>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <div
//       className={`testArrow testPrev ${isFirstSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowBack />
//     </div>
//   );

//   const settings = {
//     infinite: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,

//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 486,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === data.length - 3);
//     },
//   };
//   const settings2 = {
//     infinite: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,

//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 486,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === data.length - 1);
//     },
//   };

//   return (
//     <>
//       <div className="container mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-2 mt-sm-2 mt-2 mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3 mb-sm-2 mb-2">
//         <div className="row">
//           <div className="col-12 my-xl-4 my-lg-3  my-2">
//             <h3 className="abtMetsryh1 ">
//               What our <span className="banHeading">clients</span> say.
//             </h3>
//           </div>

//           <Slider {...settings}>
//             {data?.map((item, i) => {
//               const { img, description, description2, title, city } = item;
//               return (
//                 <div key={i} className="p-1">
//                   <div className="card border-0 testCardBg">
//                     <div className="position-relative d-flex justify-content-center">
//                       <img
//                         src={img}
//                         className="card-img-top testCardImg"
//                         alt="..."
//                       />
//                       <div class="card-img-overlay testCard-overlay">
//                         <FaPlay className="faplayIcon" />
//                       </div>
//                     </div>
//                     <div className="card-body testBodybg">
//                       <h5 className="card-title testTitle text-center">
//                         {title}
//                       </h5>

//                       <p className="card-text abtP text-center">
//                         {description}
//                       </p>
//                       <p className="card-text abtP text-center">{city}</p>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </Slider>
//         </div>
//       </div>
//       <Modal show={show} onHide={handleClose} fullscreen>
//         <Modal.Header closeButton></Modal.Header>
//         <Modal.Body> </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Testimonial;

// import React, { useState } from "react";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import { FaPlayCircle } from "react-icons/fa";
// import { FaCirclePlay } from "react-icons/fa6";
// import "./testimonial.css";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { FaPlay } from "react-icons/fa";
// import Modal from "react-bootstrap/Modal";
// import person1 from "../../../assets/person8.jpg";
// import person2 from "../../../assets/person2.jpeg";
// import person3 from "../../../assets/person3.jpeg";
// import person4 from "../../../assets/person4.jpeg";
// import person5 from "../../../assets/person5.jpeg";
// import UseMediaQuery from "../UseMediaQuery";

// const Testimonial = () => {
//   const [isFirstSlide, setIsFirstSlide] = useState(true);
//   const [isLastSlide, setIsLastSlide] = useState(false);
//   const isMobile = UseMediaQuery("(max-width:486px)");
//   const [show, setShow] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const handleClose = () => setShow(false);
//   const handleShow = (index) => {
//     setActiveIndex(index);
//     setShow(true);
//   };

//   const data = [
//     {
//       img: person1,
//       title: "Maheshwari",
//       description: "SLV Trading Corporation",
//       description2:
//         "Delivered quality materials promptly for our building project.",
//       city: "Begur",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
//     },
//     {
//       img: person4,
//       title: "Ramesh Gowda",
//       description: "Sri Lakshmi Enterprises",
//       description2:
//         "Reliable concrete supply and professional construction service.",
//       city: "Whitefield",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
//     },
//     {
//       img: person2,
//       title: "Anitha",
//       description: "Om Sai Constructions",
//       description2: "Designed and built our office with great precision.",
//       city: "KR Puram",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
//     },
//     {
//       img: person3,
//       title: "Manjunath Reddy",
//       description: "BuildTech Solutions",
//       description2:
//         "Delivered civil work efficiently with excellent attention.",
//       city: "Marathahalli",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
//     },
//     {
//       img: person5,
//       title: "Ramalinga",
//       description: "Modern Interiors",
//       description2:
//         "Beautifully transformed our interiors with creative design.",
//       city: "Yeshwanthapura",
//       video:
//         "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
//     },
//   ];

//   const NextArrow = ({ onClick }) => (
//     <div
//       className={`testArrow testNext ${isLastSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowForward />
//     </div>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <div
//       className={`testArrow testPrev ${isFirstSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowBack />
//     </div>
//   );

//   const settings = {
//     infinite: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 2 } },
//       { breakpoint: 486, settings: { slidesToShow: 1 } },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === data.length - 3);
//     },
//   };

//   const settings2 = {
//     infinite: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 2 } },
//       { breakpoint: 486, settings: { slidesToShow: 1 } },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === data.length - 1);
//     },
//   };

//   return (
//     <>
//       <div className="container mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-2 mt-sm-2 mt-2 mb-xxl-4 mb-xl-4 mb-lg-4 mb-md-3 mb-sm-2 mb-2">
//         <div className="row">
//           <div className="col-12 mt-xl-4 mt-lg- mb-xl-4 mb-lg-4 my-2">
//             <h3 className="abtMetsryh1">
//               What our <span className="banHeading">clients</span> say.
//             </h3>
//           </div>

//           {isMobile ? (
//             <Slider {...settings2}>
//               {data.map((item, i) => {
//                 const { img, description, description2, title, city, video } =
//                   item;
//                 return (
//                   <div key={i} className="p-1">
//                     <div className="card border-0 testCardBg">
//                       <div
//                         className="position-relative d-flex justify-content-center cursor-pointer"
//                         onClick={() => handleShow(i)}
//                       >
//                         <img
//                           src={img}
//                           className="card-img-top testCardImg"
//                           alt={title}
//                         />
//                         <div className="card-img-overlay testCard-overlay">
//                           <FaPlay className="faplayIcon" />
//                         </div>
//                       </div>
//                       <div className="card-body testBodybg">
//                         <h5 className="card-title testTitle text-center">
//                           {title}
//                         </h5>
//                         <p className="card-text abtP text-center">
//                           {description2}
//                         </p>
//                         <p className="card-text testTitle text-center">
//                           {city}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </Slider>
//           ) : (
//             <Slider {...settings}>
//               {data.map((item, i) => {
//                 const { img, description, description2, title, city, video } =
//                   item;
//                 return (
//                   <div key={i} className="p-1">
//                     <div className="card border-0 testCardBg">
//                       <div
//                         className="position-relative d-flex justify-content-center cursor-pointer"
//                         onClick={() => handleShow(i)}
//                       >
//                         <img
//                           src={img}
//                           className="card-img-top testCardImg"
//                           alt={title}
//                         />
//                         <div className="card-img-overlay testCard-overlay">
//                           <FaPlay className="faplayIcon" />
//                         </div>
//                       </div>
//                       <div className="card-body testBodybg">
//                         <h5 className="card-title testTitle text-center">
//                           {title}
//                         </h5>
//                         <p className="card-text abtP text-center">
//                           {description2}
//                         </p>
//                         <p className="card-text testTitle text-center">
//                           {city}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </Slider>
//           )}
//         </div>
//       </div>

//       {/* Video Modal */}
//       <Modal
//         show={show}
//         onHide={handleClose}
//         fullscreen={isMobile}
//         size={isMobile ? undefined : "lg"}
//         className="rounded-1"
//       >
//         <Modal.Header closeButton></Modal.Header>
//         <Modal.Body className="d-flex justify-content-center align-items-center bg-black">
//           <video
//             src={data[activeIndex]?.video}
//             controls
//             autoPlay
//             style={{
//               width: isMobile ? "100%" : "80%",
//               height: "auto",
//               borderRadius: "10px",
//             }}
//           />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Testimonial;

import React, { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaPlayCircle } from "react-icons/fa";
import { FaCirclePlay } from "react-icons/fa6";
import "./testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaPlay } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import person1 from "../../../assets/person8.jpg";
import person2 from "../../../assets/person2.jpeg";
import person3 from "../../../assets/person3.jpeg";
import person4 from "../../../assets/person4.jpeg";
import person5 from "../../../assets/person5.jpeg";
import UseMediaQuery from "../UseMediaQuery";

const Testimonial = () => {
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const isMobile = UseMediaQuery("(max-width:486px)");
  const [show, setShow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = (index) => {
    setActiveIndex(index);
    setShow(true);
  };

  const data = [
    {
      img: person1,
      title: "Maheshwari",
      description: "SLV Trading Corporation",
      description2:
        "Delivered quality materials promptly for our building project.",
      city: "Begur",
      video:
        "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
    },
    {
      img: person4,
      title: "Ramesh Gowda",
      description: "Sri Lakshmi Enterprises",
      description2:
        "Reliable concrete supply and professional construction service.",
      city: "Whitefield",
      video:
        "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    },
    {
      img: person2,
      title: "Anitha",
      description: "Om Sai Constructions",
      description2: "Designed and built our office with great precision.",
      city: "KR Puram",
      video:
        "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    },
    {
      img: person3,
      title: "Manjunath Reddy",
      description: "BuildTech Solutions",
      description2:
        "Delivered civil work efficiently with excellent attention.",
      city: "Marathahalli",
      video:
        "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
    },
    {
      img: person5,
      title: "Ramalinga",
      description: "Modern Interiors",
      description2:
        "Beautifully transformed our interiors with creative design.",
      city: "Yeshwanthapura",
      video:
        "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    },
  ];

  const NextArrow = ({ onClick }) => (
    <div
      className={`testArrow testNext ${isLastSlide ? "iconHidden" : ""}`}
      onClick={onClick}
    >
      <IoIosArrowForward />
    </div>
    // <div className="testArrow testNext " onClick={onClick}>
    //   <IoIosArrowForward />
    // </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className={`testArrow testPrev ${isFirstSlide ? "iconHidden" : ""}`}
      onClick={onClick}
    >
      <IoIosArrowBack />
    </div>
    // <div className="testArrow testPrev" onClick={onClick}>
    //   <IoIosArrowBack />
    // </div>
  );

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 486, settings: { slidesToShow: 1 } },
    ],
    beforeChange: (current, next) => {
      setIsFirstSlide(next === 0);
      setIsLastSlide(next === data.length - 3);
    },
  };

  const settings2 = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 486, settings: { slidesToShow: 1 } },
    ],
    beforeChange: (current, next) => {
      setIsFirstSlide(next === 0);
      setIsLastSlide(next === data.length - 1);
    },
  };

  return (
    <>
      <div className="container mt-xxl-3 mt-xl-3 mt-lg-3 mt-md-2 mt-sm-2 mt-2 mb-xxl-4 mb-xl-4 mb-lg-4 mb-md-3 mb-sm-2 mb-2">
        <div className="row">
          <div className="col-12 mt-xl-4 mt-lg- mb-xl-4 mb-lg-4 my-2">
            <h3 className="abtMetsryh1">
              What our <span className="banHeading">clients</span> say.
            </h3>
          </div>

          {isMobile ? (
            <Slider {...settings2}>
              {data.map((item, i) => {
                const { img, description, description2, title, city, video } =
                  item;
                return (
                  <div key={i} className="p-1">
                    <div className="card border-0 testCardBg">
                      <div className="position-relative d-flex justify-content-center cursor-pointer">
                        <img
                          src={img}
                          className="card-img-top testCardImg"
                          alt={title}
                        />
                        <div className="card-img-overlay testCard-overlay">
                          <FaPlay
                            className="faplayIcon"
                            onClick={() => handleShow(i)}
                          />
                        </div>
                      </div>
                      <div className="card-body testBodybg">
                        <h5 className="card-title testTitle text-center">
                          {title}
                        </h5>
                        <p className="card-text abtP text-center">
                          {description2}
                        </p>
                        <p className="card-text testTitle text-center">
                          {city}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          ) : (
            <Slider {...settings}>
              {data.map((item, i) => {
                const { img, description, description2, title, city, video } =
                  item;
                return (
                  <div key={i} className="p-1">
                    <div className="card border-0 testCardBg">
                      <div className="position-relative d-flex justify-content-center cursor-pointer">
                        <img
                          src={img}
                          className="card-img-top testCardImg"
                          alt={title}
                        />
                        <div className="card-img-overlay testCard-overlay">
                          <FaPlay
                            className="faplayIcon"
                            onClick={() => handleShow(i)}
                          />
                        </div>
                      </div>
                      <div className="card-body testBodybg">
                        <h5 className="card-title testTitle text-center">
                          {title}
                        </h5>
                        <p className="card-text abtP text-center">
                          {description2}
                        </p>
                        <p className="card-text testTitle text-center">
                          {city}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          )}
        </div>
      </div>

      {/* Video Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        fullscreen={isMobile}
        size={isMobile ? undefined : "lg"}
        className="rounded-1"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="d-flex justify-content-center align-items-center bg-black">
          <video
            src={data[activeIndex]?.video}
            controls
            autoPlay
            style={{
              width: isMobile ? "100%" : "80%",
              height: "auto",
              borderRadius: "10px",
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Testimonial;
